// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mHUC","content":"styles_content__3e0Xm"};